
import useHooks from '@/hooks/index.hooks';
import useReportHooks, { TableData } from '@/hooks/report.hooks';
import { Page } from '@/interface/index.interface';
import { cloneDeep } from '@/lib';
import { definitions } from '@/types/api';
import { Pagination, Table } from 'ant-design-vue';
import {
  defineComponent, reactive, toRefs, computed,
} from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  components: {
    aTable: Table,
    aPagination: Pagination,
  },
  setup() {
    const { getPageOption } = useHooks();
    const reportHooks = useReportHooks();
    const router = useRouter();
    const tableData = reactive<Page & TableData>({
      tableList: [],
      tableLoading: false,
      columns: cloneDeep(reportHooks.reportColumns),
      /** */
      pageNo: 1,
      pageSize: 10,
      total: 0,
      pageOption: cloneDeep(getPageOption),
    });
    /** 查询列表 */
    const getList = async () => {
      tableData.tableLoading = true;
      const { pageNo, pageSize } = tableData;
      const { list, total } = await reportHooks.listExperimentList({ pageNo, pageSize });
      Object.assign(tableData, {
        tableList: list, total, tableLoading: false,
      });
    };
    const tableMethod = reactive({
      /** 禁用查看-学生状态 */
      stuStatus: computed(() => (record: definitions['ExperimentScorePersonnelResponse']) => {
        /** 只有实验结束才能看详情 */
        if (record.groupStatus === 2) return false;
        return true;
      }),
      /** 状态文案 */
      getStatus: computed(() => (status: number) => {
        if (status === 0) return '未开始';
        if (status === 1) return '进行中';
        if (status === 2) return '已结束';
        return '-';
      }),
      /** 跳转详情页 */
      gotoInfo: (record: definitions['Experiment']) => {
        reportHooks.currentReportDate.set(record.createTime || '');
        router.push({
          path: `/Student/reportInfo/${record.id}`,
        });
      },
    });

    const pageMethod = reactive({
      showSizeChange: (_: unknown, size: number) => {
        tableData.pageSize = size;
        tableData.pageNo = 1;
        getList();
      },
      pageChange: (page: number) => {
        tableData.pageNo = page;
        getList();
      },
    });

    getList();
    return {
      ...toRefs(tableData),
      ...toRefs(pageMethod),
      ...toRefs(tableMethod),
    };
  },
});
